import React from 'react';
import styled from 'styled-components';

type Align = 'left' | 'center' | 'right';

interface BlockWithVisibleProps {
  width: string;
  isColumn?: boolean;
  value: string | number;
  isHover?: boolean;
  isActive?: boolean;
  align?: Align;
}

const BlockWithVisible: React.FC<BlockWithVisibleProps> = ({
  width,
  isColumn,
  value,
  isHover,
  isActive,
  align = 'center',
}) => {

  return (
      <Block $width={width}
        $isColumn={isColumn}
        $isHover={isHover}
        $isActive={isActive}
        $align={align}>
        <Value $isColumn={isColumn} $align={align}>
          {value}
        </Value>
      </Block>
  )
}


const Block = styled.div<{
  $width: string;
  $isColumn: boolean | undefined;
  $isHover: boolean | undefined;
  $isActive: boolean | undefined;
  $align: Align;
}>`
  flex: ${({ $width }) => $width};

  display: flex;
  justify-content: ${({ $align }) =>
    $align === 'left' ? 'flex-start' : $align === 'right' ? 'flex-end' : 'center'};
  align-items: center;

  min-width: 0;

  border-bottom: ${({ $isColumn, theme }) =>
    $isColumn ? 'none' : `0.5px solid ${theme.colors.color_Gray_04}`};
  cursor: ${({ $isHover }) => $isHover ? 'pointer' : 'default'};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive
      ? theme.colors.color_Gray_06
      : $isHover
        ? theme.colors.color_Gray_07
        : 'transparent'};
  user-select: none;
`

const Value = styled.span<{ $isColumn: boolean | undefined; $align: Align }>`
  width: 80%;

  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;

  padding-left: ${({ $isColumn, $align }) =>
    $align === 'left' && !$isColumn ? '4px' : '0px'};
  padding-right: ${({ $align }) => $align === 'right' ? '4px' : '0px'};

  text-align: ${({ $align }) => $align};
`

export default BlockWithVisible;
